// Saving a lineup to the server. BACKLOG E2's endpoint, from the screen.
//
// THE LINEUP SCREEN SAVED TO THE SIMULATOR UNTIL 2026-09-24, for every league:
// `swap` from `useSim()` looks the team up in the practice world, so on a real
// league every tap answered "Unknown team" in red. A real league saves here,
// through the same refusal the server gives anybody — a locked slot, a player
// who cannot play there, a team that is not yours.
//
// ONLY THE SLOTS THAT CHANGE are sent: a swap is two cells, and the endpoint
// leaves every cell it is not given exactly as it was.
//
// AND WHAT SHOWS IT IS READ AGAIN, like a move (`movesChanged`). The reply is
// the lineup, but the lineup is not the only read a swap changes: Game Day's
// projected totals and win chance are the MATCHUP's, and Home's health bar is
// the lineup's verdict. Reads do not poll, so without this the
// header kept the total from before the swap under a footnote saying it moves
// (the review of round 2, SCREENS-1). Asked again whatever came back: a
// refusal can mean the lineup moved under the screen.

import { LineupView, type SaveLineupRequest } from '@fsp/domain';
import { send, type Reply } from './api';
import { movesChanged } from './moves';

export async function saveLineup(
  leagueId: string,
  teamId: string,
  body: SaveLineupRequest,
): Promise<Reply<LineupView>> {
  const reply = await send('PUT', `/leagues/${leagueId}/teams/${teamId}/lineup`, body, LineupView);
  setTimeout(() => movesChanged(leagueId), 0);
  return reply;
}
